import React, { useState } from 'react';
import DynamicTable from '../../../../components/DynamicTable/DynamicTable';
import CheckboxAndData from '../../../../components/CheckboxAndData/CheckboxAndData';
import TabSelector from '../../../../components/TabSelector/TabSelector';
import styles from './GeneratedInvoice.module.css';

const GeneratedInvoice = () => {
  const [selectedStatus, setSelectedStatus] = useState('Due');

  const headings = [
    {
      title: (
        <CheckboxAndData
          label=""
          onChange={() => {}}
          checkboxSize={16}
          labelSize={0}
        />
      ),
      accessor: 'checkbox',
    },
    { title: 'Invoice ID', accessor: 'invoiceId' },
    { title: 'Due Date', accessor: 'dueDate' },
    { title: 'Pending', accessor: 'pending' },
    { title: 'Total', accessor: 'total' },
    { title: 'Payment Date', accessor: 'paymentDate' },
  ];

  const columnData = []; // Can be dynamic later

  const statusOptions = [{ label: 'Due' }, { label: 'Paid' }];

  const [summaryData, setSummaryData] = useState([
    {
      title: '0 Due Invoices',
      value: 'INR 0',
    },
    {
      title: '0 Paid Invoices',
      value: 'INR 0',
    },
    {
      title: 'Invoice Refund Amount',
      value: 'INR 0',
    },
  ]);

  return (
    <div className={styles.GeneratedInvoice}>
      {/* Summary Section */}
      <div className={styles.summaryContainer}>
        <div className={styles.totalHeader}>
          <span>Total Amount</span>
          <span>INR 0</span>
        </div>

        <div className={styles.subCards}>
          {summaryData.map((item, index) => (
            <div key={index} className={styles.subCard}>
              <span>{item.title}</span>
              <span>{item.value}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.statusTabs}>
        <TabSelector
          options={statusOptions}
          activeTab={selectedStatus}
          setActiveTab={setSelectedStatus}
        />
      </div>

      {/* Table */}
      <div className={styles.tableWrapper}>
        <DynamicTable headings={headings} columnData={columnData} />
      </div>
    </div>
  );
};

export default GeneratedInvoice;
